/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { manufacturersTableGrid } from './TableHead';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

// variables custom Import
import * as commonConstant from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { navigateToRequest } from './ConstantData';

import {
  STATUS_MSG,
  SUCCESS_MSG,
  REBATE_PROGRAM_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  QUARTER_VALUE_REQUIRED,
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  handleScrollToEvent,
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchErrorMsgMCOClaims,
  getPlanTypeValues,
  getRebateProgrameList,
  getManufacturerList,
  mcoClaimsSearchObj,
  setRebatePrograme,
  dispatchRebatePrograme,
  getSelectedOption,
  dispatchURAtype,
  dispatchQtrValue,
  getManufactureName,
  getManufactureID,
  dispatchAllMfgChecked,
  getMCOClaimsData,
  dispatchDisplayObjMcoClaims,
} from '../Store/Actions';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const RequestMCOClaims = (props) => {
  // initial
  // use Selector function

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const requestMCOClaimsScreenData = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.mcoClaimsSearchObj
  );
  const {
    isMfgChecked: checkedValue,
    quarterValue: quarterValues,
    selectedOption,
    uraType: uraTypeValues,
  } = useSelector((state) => state?.sharedState?.MCOClaimsReducer);
  const planTypeList = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.planType
  );
  const rebateProgramValue = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.setRebateProgram
  );
  const getRebateProgramList = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.rebateProgram
  );

  const getErrorMsg = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.errorMsgMcoClaims
  );

  const isLoading = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.isLoading
  );

  const resultManufacturerList = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.manufacturerList
  );
  const getSearchResult = useSelector(
    (state) => state?.sharedState?.MCOClaimsReducer?.searchResult
  );

  const dispatch = useDispatch();
  const gridRef = React.useRef();
  const history = useHistory();
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [selectedValue, setselectedValue] = React.useState(selectedOption);
  const [checked, setChecked] = React.useState(checkedValue);
  const [uraType, setUraType] = React.useState(uraTypeValues);
  const [radioList, setRadioList] = React.useState([]);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [manufacturerList, setManufacturerList] = React.useState([
    resultManufacturerList.rebatePercentOfSpendMfgGridVO,
  ]);

  const [menuName, setMenuName] = React.useState('ALL');
  const [manufacturerWithId, setManufactureWithId] = React.useState([]);
  // current Quarter
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
  const currentYear = currentDate.getFullYear();
  const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter
  const formattedQuarter = `${currentQuarter}Q${currentYear.toString()}`;
  const [quarterValue, setQuarterValue] = React.useState(formattedQuarter);
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // states with initial values
  const [state, setState] = React.useState(
    requestMCOClaimsScreenData?.state
      ? requestMCOClaimsScreenData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd:
            rebateProgramValue || userDefaults?.rebateProgramCd
              ? userDefaults?.rebateProgramCd
              : '-1',
          // reportDetailLevel: 'NDC',
          // uraType: 'Invoice',
          quarterValue: quarterValue,
        }
  );

  // dispatch function
  const setMcoClaimsSearchObj = (value) => dispatch(mcoClaimsSearchObj(value));

  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);

  React.useEffect(() => {
    setselectedValue(selectedValue);
  }, [selectedValue]);

  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);

  // set Rebate Program List
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(state.planTypeCd)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  // get rebate program
  React.useEffect(() => {
    if (state.planTypeCd) {
      rebatepgmDropdown(state.planTypeCd);
    }
  }, [state.planTypeCd]);

  // Manufacturer Grid From API
  React.useEffect(() => {
    if (state.planTypeCd) {
      setManufacturerList(resultManufacturerList);
    }
  }, [resultManufacturerList]);

  React.useEffect(() => {
    if (state.planTypeCd) {
      dispatch(
        getManufacturerList({
          planType: state.planTypeCd,
          asMode: 1,
        })
      );
    }
  }, [state.planTypeCd]);

  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgMCOClaims([]));
  }, [checked, selectedValue,uraType]);


  // handle- onchange functionality

  const handleOnChangeEvent = (value, name) => {
    dispatch(dispatchErrorMsgMCOClaims([]));
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setMcoClaimsSearchObj({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setMcoClaimsSearchObj({
        state: { ...state, [name]: value },
      });
    }

    if (name === 'quarterValue') {
      setQuarterValue(value);
      setState({ ...state, [name]: value });
      setMcoClaimsSearchObj({
        state: { ...state, [name]: value },
      });
    }
    if (name === 'reportDetailLevel') {
      setState({ ...state, [name]: value });
      setMcoClaimsSearchObj({
        state: { ...state, [name]: value },
      });
    }
    if (name === 'uraType') {
      setState({ ...state, [name]: value });
      setMcoClaimsSearchObj({
        state: { ...state, [name]: value },
      });
    }
  };

  // on blur functionality on field level
  const handleOnblurEvent = (type, value) => {
    dispatch(dispatchErrorMsgMCOClaims([]));
    let localErr = getErrorMsg || [];
    const data = value;

    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    if (type === 'quarterValue') {
      if (data && !_.isEmpty(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          const formattedQuarterValue = autoFormateDate(value?.toUpperCase());
          setQuarterValue(formattedQuarterValue);
          setState({
            ...state,
            quarterValue: formattedQuarterValue,
          });
          setMcoClaimsSearchObj({
            state: {
              ...state,
              quarterValue: formattedQuarterValue,
            },
          });
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: QUARTER_VALUE_REQUIRED,
        });
      }
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgMCOClaims(unique));
  };

  const onSelectionChanged = (e) => {
    dispatch(dispatchErrorMsgMCOClaims([]));
    const selectedRows = e?.api?.getSelectedRows();
    setSelectedRows(selectedRows);

    if (selectedRows) {
      setMenuName(selectedRows[0]?.mfgName);
      setManufactureWithId(selectedRows[0]?.mfgId);

      let localErr = getErrorMsg || [];
      localErr = localErr.filter((item) => item.field != 'nomanufacture');
      const unique = [...new Set(localErr)];
      dispatch(dispatchErrorMsgMCOClaims(unique));
    }
  };
  // uncheck manufacturer grid
  const checkManufacturer = (e) => {
    dispatch(dispatchErrorMsgMCOClaims([]));
    setChecked(!checked);
    if (!checked) onSelectionChanged({}, !checked);

    let localErr = getErrorMsg || [];
    localErr = localErr?.filter((item) => item.field != 'nomanufacture');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgMCOClaims(unique));
  };

  // full Screen functionality
  const handleFullScreenView = () => {
    dispatch(dispatchErrorMsgMCOClaims([]));
    setFullScreenView(!fullScreenView);
  };

  //  tab highliter Functionality
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther(navigateToRequest, true);
    } else {
      tabHighLigther(navigateToRequest, false);
    }
  }, [JSON.stringify(getErrorMsg)]);

  // doubleClick mfg
  const getSelectedRowData = () => {
    const selectedData = this?.gridApi?.getSelectedRows();
    return selectedData;
  };

  // Search button on click functionality
  const onClickOnSearch = (e, doubleClicked = false, doubleClickedData) => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    )?.rebateProgramCd;
    const rebateProgrameName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = [];
    if (state.rebateProgramCd === '-1') {
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    let sRows = (checked ? manufacturerList : selectedRows) || [];
    const enteredQuarter = state.quarterValue;
    if (!enteredQuarter || _.isEmpty(enteredQuarter)) {
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    } else if (
      !(
        quarterTest1.test(enteredQuarter) ||
        quarterTest2.test(enteredQuarter)
      )
    ) {
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: VALIDATE_QUARTER_VALUE,
      });
    }

    // All Manufacturers checked is valid; otherwise a manufacturer must be selected
    if (!checked && (!sRows || sRows.length === 0)) {
      localErr.push({
        field: 'nomanufacture',
        errorType: 'manufactureRequired',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgMCOClaims(unique));

    if (unique.length === 0) {
      setSearchClicked(true);
      dispatch(setRebatePrograme(rebateProgramName));
      dispatch(dispatchURAtype(uraType));
      dispatch(dispatchQtrValue(state.quarterValue));
      dispatch(dispatchAllMfgChecked(checked));
      dispatch(getManufactureName(checked ? menuName : sRows[0]?.mfgName,));
      dispatch(getManufactureID(manufacturerWithId));
      dispatch(getSelectedOption(selectedValue));
      dispatch(
        dispatchDisplayObjMcoClaims({
          displayObj: {
            rebateProgrameName,
            setRebateProgram: rebateProgramName,
            quarter: state.quarterValue,
            rebateProgram: getRebateProgramList,
            planType: planTypeList,
            selectedOption: selectedValue,
            uraType: uraType,
            isMfgChecked: checked,
          },
        })
      );
      dispatch(
      getMCOClaimsData(
        {
          mfgId: checked ? 'ALL' : sRows[0]?.mfgId,
          rebateProgramCd: state.rebateProgramCd,
          qtr: state.quarterValue,
          reportDetailLevel: selectedValue,
          uraType: uraType,
        },
        true
      )
    );
    }
  };
  // For No Data validation for auto Scroll
  React.useEffect(() => {
    if (isSearchClicked && getErrorMsg?.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [getErrorMsg]);

  if (isSearchClicked && getSearchResult?.length > 0) {
    setSearchClicked(false);
    props.history.push({
      pathname: '/display_mco_claims',
    });
    dispatch(clearReduxForFilterAndSort('/display_mco_claims'));

    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/display_mco_claims',
      value: 'Display MCO Claims',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }
  const cellClickedListener = (e) => {
    dispatch(dispatchErrorMsgMCOClaims([]));
    onClickOnSearch(null, true, [e.data]);
  };
  const [gridApi, setGridApi] = React.useState(null);
      const onGridReady = (params) => {
        setGridApi(params.api);
      };
      React.useEffect(() => {
        if (!gridApi || manufacturerList === 0) return;
        const selectedRows = gridApi.getSelectedRows();
        if (selectedRows.length > 0) return;
        const firstNode = gridApi.getDisplayedRowAtIndex(0);
        if (firstNode) {
          firstNode.setSelected(true);
          onSelectionChanged({ api: gridApi }); 
        }
      }, [gridApi, manufacturerList]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator parent1="Detail Reports" parent2="Req MCO Claims" />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              getErrorMsg?.length > 0
                ? _.map(getErrorMsg, (l) => l.message)
                : []
            ),
          ]}
        />
      ) : null}
      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              id="filter-plan-by-radio-btn-action"
              data-testid="chip-cshcn-Rebate-Program"
              labelName={commonConstant.radioGroupLabelNamePlan}
              required
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div>
            <fieldset className="custom-fieldset" style={{ padding: '0px' }}>
              <legend className="same-font-family">
                Report Detail Level <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="col-4 frr-two-col-radio">
                <div className="mui-custom-form input-md field-xl">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup row name="Report Type" value={selectedValue}>
                        <FormControlLabel
                          value="ndc"
                          data-testid="req-NDC-payment-ndc"
                          control={<Radio />}
                          label="NDC"
                          name="NDC"
                          onChange={(e) => setselectedValue(e.target.value)}
                        />
                        <FormControlLabel
                          value="mfg"
                          data-testid="req-NDC-payment-mfg"
                          control={<Radio />}
                          label="Manufacturer"
                          name="Manufacturer"
                          onChange={(e) => setselectedValue(e.target.value)}
                        />
                        <FormControlLabel
                          value="tot"
                          data-testid="req-NDC-payment-tot"
                          control={<Radio />}
                          label="Totals"
                          onChange={(e) => setselectedValue(e.target.value)}
                          name="Totals"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-4 frr-two-col-radio ">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    id="rebate_program"
                    data-testid="req-NDC-payment-quarter"
                    label={commonConstant.rebateProgramLabelName}
                    fullWidth
                    select
                    required
                    placeholder=""
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={state && state.rebateProgramCd}
                    onChange={(e) =>
                      handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                    }
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList?.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div className="row">
          <div
            className="col-4 frr-two-col-radio"
            style={{ paddingTop: '10px' }}
          >
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                URA Type <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="form-wrapper p-3">
                <div className="mui-custom-form input-md field-xl">
                  <div className="sub-radio no-margin">
                    <FormControl>
                      <RadioGroup row name="uraType" value={uraType}>
                        <FormControlLabel
                          value="inv"
                          data-testid="req-NDC-payment-inv"
                          control={<Radio />}
                          label="Invoice"
                          name="Invoice"
                          onChange={(e) => setUraType(e.target.value)}
                        />

                        <FormControlLabel
                          value="cur"
                          data-testid="req-NDC-payment-cur"
                          control={<Radio />}
                          label="Current"
                          name="Current"
                          onChange={(e) => setUraType(e.target.value)}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div
            className="col-4"
            style={{
              paddingLeft: '2px',
              paddingTop: '3px',
              marginTop: '7px',
            }}
          >
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Quarter <span className="mandatory"> *</span>{' '}
              </legend>
              <div className="mui-custom-form with-select field-xl no-lbl">
                <TextField
                  id="check_by_invoice_quater"
                  label="check_by_invoice_quater"
                  data-testid="req-NDC-payment-quarter"
                  required
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={state && state.quarterValue}
                  onChange={(e) => {
                    handleOnChangeEvent(e.target.value, 'quarterValue');
                  }}
                  className={
                    getErrorMsg?.some((l) => l.field === 'quarter')
                      ? 'mandate-fields'
                      : null
                  }
                  onBlur={(e) =>
                    handleOnblurEvent('quarterValue', e.target.value)
                  }
                  helperText={
                    getErrorMsg?.find((l) => l.field === 'quarter')?.message ||
                    null
                  }
                  error={getErrorMsg?.some((l) => l.field === 'quarter')}
                />
              </div>
            </fieldset>
          </div>
          <div
            className="col-4"
            style={{ paddingLeft: '60px', marginTop: '70px' }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  color="primary"
                  name="allManufacturers"
                  onChange={checkManufacturer}
                  checked={checked}
                  value={menuName}
                />
              }
              label="All Manufacturers"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="view_detail_ia"
                type="button"
                onClick={onClickOnSearch}
              >
                {' '}
                <SVGComponent iconName="Icon-search" /> {'  '} Search
              </Button>
            </div>
          </div>
        </div>
        <div className="row">
          {!checked && (
            <div
              className="hcpcs col-12 unallocated"
              style={{ paddingLeft: '15px', width: '76vw' }}
            >
              <TableGrid
                getSelectedRowData={getSelectedRowData}
                onSelectionChanged={onSelectionChanged}
                ref={gridRef}
                gridCall={onGridReady}
                helpMessage
                fullScreenView={fullScreenView}
                handleFullScreenViewClick={handleFullScreenView}
                gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
                columnDefs={manufacturersTableGrid}
                rowData={manufacturerList || []}
                rowSelection="single"
                cellClickedListener={cellClickedListener}
                rowMultiSelectWithClick
                fileName="Manufacturing List"
                data-testid="onEditingStopped"
                enterMovesDown
                suppressCellFocus
                singleClickEdit
                exportFile
                hideColumnsInPdf
                frameworkComponents={{
                  TextBoxRender: (cellInfo) => {
                    const name = cellInfo?.value;

                    if (name && name.length > 30) {
                      return (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="labeler-tooltip">{name}</Tooltip>
                          }
                        >
                          <div>{name && `${name.substring(0, 30)}...`}</div>
                        </OverlayTrigger>
                      );
                    }
                    return <div>{name}</div>;
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestMCOClaims;
